import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "2em 1em 2em 1em",
  },
}));

/**
 * @param {any} props
 */

export default function Form(props) {
  const classes = useStyles();
  return (
    <>
      <form className={classes.root} autoComplete="off">
        {props.children}
      </form>
    </>
  );
}

